module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/bg_registration-0fea841d085987a7bcb4746b897d1eaf.png";